import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { customerAuthInterceptor } from './features/ordering/data/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    // This app ships WITHOUT zone.js (no zone.js dependency, no polyfill) — it is ZONELESS.
    // Change detection is driven by signals, template events and explicit scheduling, NOT by
    // zone-patched async APIs. So async work (HTTP, geolocation, fetch, timers) does NOT auto-run
    // CD: any component state a template reads must live in a signal so the view updates when it
    // changes. Declaring it explicitly keeps Angular's scheduler in zoneless mode (and silences the
    // dev-mode "missing zoneless/zone" warning).
    provideZonelessChangeDetection(),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    // Attaches the customer token to customer-scoped API calls and drives the refresh/expiry flow.
    provideHttpClient(withInterceptors([customerAuthInterceptor])),
  ],
};
